import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import Qs from 'qs'
import store from '@/store'


// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: '/',
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

axios.defaults.baseURL = '/api';

//get请求时，参数转换
_axios.defaults.paramsSerializer = (params) => {
  return Qs.stringify(params);
}
//post请求时，参数转换
_axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

_axios.interceptors.request.use(
  function (config) { // Do something before request is sent    
    let token = localStorage.getItem("token");
    if (token) {
      //每个请求携带 token
      config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
  },
  function (error) {  // Do something with request error
    console.log('request_error');
    console.log(error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
// 添加一个 response 拦截器
_axios.interceptors.response.use(
  async function (response) { // Do something with response data

    // console.log(response);
    let res = response.data;
    if (response.request.responseType == 'blob') {
      if (response.headers["content-type"].indexOf("application/json") == -1) {
        return response;
      }
      async function convertJson() {
        return new Promise((resolve, reject) => {
          console.log('resolve');
          // console.log(resolve);
          let reader = new FileReader();
          reader.onload = e => {
            resolve(JSON.parse(e.target.result));
          };
          reader.readAsText(res);
        })
      }
      res = await convertJson();
    }
    // console.log(res.Code)
    if (res.Code == 0) {
      return res;
    }

    if (res.Code == 401) {
      store.dispatch('refreshToken').then(rst => {
        // console.log('refresh', rst)
        if (rst.Code == 1 || rst.Data == null) {
          MessageBox({
            title: "提示",
            message: res.Msg,
            type: 'error',
          }).then(res => {
            store.dispatch('clearStorage');
            window.location.href = window.location.origin + '/#/login';
            window.location.reload()
          })
          return Promise.reject(res)
        }
      })
    }

    /* 错误处理 */

    // // code大于1000的为全局错误码，

    // if (res.code > 1000) {
    //   // console.log(res)
    //   switch (res.code) {
    //     case 1001:
    //     case 1003:
    //       MessageBox({
    //         title: "认证授权失败",
    //         message: res.message,
    //         type: 'error',
    //       }).then(res => {
    //         store.dispatch('logout')
    //       })
    //       break;
    //     case 1002:
    //       MessageBox({
    //         title: "认证授权失败",
    //         message: res.message,
    //         type: 'warning'
    //       })
    //       break;
    //     case 2001:
    //       MessageBox({
    //         title: "访问错误",
    //         message: res.message,
    //         type: 'error'
    //       })
    //       break;
    //     case 4001:
    //       MessageBox({
    //         title: "操作失败",
    //         message: res.message,
    //         type: 'error'
    //       })
    //       break;
    //   }
    //   return Promise.reject(res)
    // }

    // // code小于0的，为不可预料的错误码
    // if (res.code < 0) {
    //   // console.log(res)
    //   MessageBox({
    //     title: "访问异常",
    //     message: "<b>异常ID</b>：" + res.data + "<br/>访问出现异常，请及时向系统管理员汇报，并将此异常ID给管理员。",
    //     type: 'error',
    //     dangerouslyUseHTMLString: true
    //   })
    //   return Promise.reject(res)
    // }

    /***********/

    return res;
  },
  async function (error) { // Do something with response error
    console.log('response_error');
    console.log(error);
    // MessageBox({
    //   title: "服务器未响应",
    //   message: error.message,
    //   type: 'error'
    // })
    return Promise.reject(error);
  }
);

export default _axios;
